require('../../modules/es6.string.includes');
module.exports = require('../../modules/$.core').String.includes;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/string/includes.js
// module id = 1095
// module chunks = 0